import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PaymenttermService {

  constructor(private http: HttpClient) { }

  getPaymentTermList(index?,includeDeleted?) {
    const typeIndex = (index ?? 0);
    let url = '';
    if(typeIndex==0){
      url = 'PaymentTerm'
    }else{
      url = 'PaymentTermVendor'
    }
    let params = new HttpParams();
    params = (!includeDeleted? params : params.append('includeDeleted', includeDeleted))
    return this.http.get<any>(`${environment.inventoryURl}${url}`, {params});
  }

  deletePaymentTerm(id,index) {
    let url = '';
    if(index==1){
      url = 'PaymentTerm'
    }else{
      url = 'PaymentTermVendor'
    }
    return this.http.delete<any>(`${environment.inventoryURl}${url}/${id}`)
      .toPromise()
      .then(res => res);
  }

  getAllGroups() {
    return this.http.get<any>(`${environment.coreUrl}Group`);
  }

  getAllPaymentTermTypes(groupId) {
    return this.http.get<any>(`${environment.coreUrl}Type?groupId=${groupId}`);
  }

  addPaymentTerm(data,index) {
    let url = '';
    if(index==0){
      url = 'PaymentTerm'
    }else{
      url = 'PaymentTermVendor'
    }
    return this.http.post<any>(`${environment.inventoryURl}${url}`, data)
      .toPromise()
      .then(res => res);
  }

  updatePaymentTerm(data,index) {
    let url = '';
    if(index==0){
      url = 'PaymentTerm'
    }else{
      url = 'PaymentTermVendor'
    }
    return this.http.put<any>(`${environment.inventoryURl}${url}`, data)
      .toPromise()
      .then(res => res);
  }
}
